import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _excluded = ["className", "style", "layout", "footer", "children", "border", "inset", "colon", "labelAlign", "inputAlign", "showValidateMessage"];
import React, { forwardRef, useContext } from 'react';
import clsx from 'clsx';
import RcForm from 'rc-field-form';
import ConfigProviderContext from '../config-provider/ConfigProviderContext';
import { FormContext } from './FormContext';
import { CellGroup } from '../cell';
var Form = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('form', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var className = props.className,
      style = props.style,
      layout = props.layout,
      footer = props.footer,
      children = props.children,
      border = props.border,
      inset = props.inset,
      colon = props.colon,
      labelAlign = props.labelAlign,
      inputAlign = props.inputAlign,
      showValidateMessage = props.showValidateMessage,
      formProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: {
      layout: layout,
      colon: colon,
      border: border,
      showValidateMessage: showValidateMessage,
      inputAlign: inputAlign,
      labelAlign: labelAlign
    }
  }, /*#__PURE__*/React.createElement(RcForm, _extends({
    className: clsx(bem(), className),
    style: style,
    ref: ref
  }, formProps), /*#__PURE__*/React.createElement(CellGroup, {
    border: border,
    inset: inset
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    className: clsx(bem('footer'))
  }, footer)));
});
Form.defaultProps = {
  showValidateMessage: true
};
export default Form;